export {
  GET_JOURNAL_ENTRIES_1099,
  GET_CONTRACTOR_LIST_WITH_INSTANCES,
  getJournalEntries1099RefetchQuery,
} from './queries';
export { DELETE_CONTRACTOR } from './mutations';
